import $ from 'jquery'
import './config/rails_ujs'
import { initSupplierOnboardingFlow } from './supplier_onboardings/supplier_onboarding_flow'
import { initSupplierSearchLanding } from './suppliers/search'
import { initContractsPage } from './contracts/contracts_page'
import { initOrganizationAutocomplete } from './organization_autocomplete'
import { logAdPageView, initPageEvents } from './page_events'
import { initConversationsPage } from './conversations'
import { initSupplierOnboardingSetPassword } from './supplier_onboarding'
import { initBusinessInfo } from 'packs/supplier_onboardings/business_info'
import { initServiceAreas } from 'packs/supplier_onboardings/service_areas'
import { initContractsTour } from 'packs/contracts/index-tour'

window.$ = window.jQuery = $

let globalsBooted = false

let slideDownSuccess
let hideSuccess
let slideDownError
let hideError

const panelTimeoutMillis = 7000

window.logAdPageView = window.logAdPageView || logAdPageView

window.successPanel = function (message) {
  const $panel = $('#success_panel')
  if (!$panel.length) return

  $('#success_panel_msg').html(message)
  clearTimeout(slideDownSuccess)
  clearTimeout(hideSuccess)

  $panel.attr('style', 'display:none;')
  const successPanelHeight = $panel.height() + 24
  $panel.attr('style', 'top:73px;')

  slideDownSuccess = setTimeout(() => {
    $panel.attr('style', `top:-${successPanelHeight + 5}px;`)
    hideSuccess = setTimeout(() => {
      $panel.attr('style', 'display:none;')
    }, 600)
  }, panelTimeoutMillis)
}

window.errorPanel = function (message) {
  const $panel = $('#error_panel')
  if (!$panel.length) return

  $('#error_panel_msg').html(message)
  clearTimeout(slideDownError)
  clearTimeout(hideError)

  $panel.attr('style', 'display:none;')
  const errorPanelHeight = $panel.height() + 24
  $panel.attr('style', 'top:73px;')

  slideDownError = setTimeout(() => {
    $panel.attr('style', `top:-${errorPanelHeight + 5}px;`)
    hideError = setTimeout(() => {
      $panel.attr('style', 'display:none;')
    }, 600)
  }, panelTimeoutMillis)
}

// Legacy globals kept for compatibility
window.userBandWidth = function () {
  const $band = $('#user_band')
  if ($band.length === 0) return
  $('#user_band_hitbox').css('width', `${$band.width()}px`)
}

window.logout = function () {
  $('#logout_panel').toggleClass('toggle-tooltip-panel')
}

window.navigationLink = function (view) {
  $('#' + view).addClass('nav-active')
}

// Spinner helpers must be global (js.erb calls them)
window.showUsersSpinner = function () {
  $('#users-list').hide()
  $('#users-search-spinner').show()
  return true
}

window.hideUsersSpinner = function () {
  $('#users-list').show()
  $('#users-search-spinner').hide()
  return true
}

window.initHomeIndex = function () {
  if (!window.jQuery) return

  $('.for_suppliers').attr('style', '')
  $('.home-route').hide()
  $('.supplier-route').show()
  $('.signup-link').show()
}

function initGlobals () {
  if (globalsBooted) return

  // Admin: organizations/suppliers auto-load into #organization-list
  const $orgList = $('#organization-list[data-search-url]')
  if ($orgList.length) {
    $.ajax({ url: $orgList.data('search-url') })
  }

  // Auto-load phonerep user list if present
  const $phonerepList = $('#phonerep-users-list[data-search-url]')
  if ($phonerepList.length) {
    $.ajax({ url: $phonerepList.data('search-url'), data: { phone_rep_search: true } })
  }

  // Handle <div data-nav-link="nav-admin">
  const navLinkTarget = document.querySelector('[data-nav-link]')
  if (navLinkTarget) {
    const id = navLinkTarget.dataset.navLink
    if (id && typeof window.navigationLink === 'function') {
      window.navigationLink(id)
    }
  }

  // Handle <div data-flash-error="...">
  const flashErrorEl = document.querySelector('[data-flash-error]')
  if (flashErrorEl && typeof window.errorPanel === 'function') {
    const msg = flashErrorEl.dataset.flashError
    if (msg) {
      window.errorPanel(msg)
    }
  }

  // Handle <div data-flash-success="...">
  const flashSuccessEl = document.querySelector('[data-flash-success]')
  if (flashSuccessEl && typeof window.successPanel === 'function') {
    const msg = flashSuccessEl.dataset.flashSuccess
    if (msg) {
      window.successPanel(msg)
    }
  }

  // Suppliers search landing tweaks
  ;(function suppliersSearchTweaks () {
    const main = document.querySelector('.main-container')
    if (main) main.style.padding = '0px'
  })()

  // Onboarding carousel
  ;(function onboardingCarousel () {
    const $slider = $('.slider')
    if (!$slider.length) return

    let slideClick = 1
    const slideCount = $slider.find('.slide').length
    const $bubbleContainer = $('#carousel-bubble')

    for (let i = 1; i <= slideCount; i++) {
      $bubbleContainer.append(`<i id="bubble_${i}" class="fas fa-circle bubble-counter"></i>`)
    }
    $(`#bubble_${slideClick}`).addClass('text-primary')

    $(document).on('click', '.slide-icon, .slide-next', function () {
      const leftPos = $slider.scrollLeft()
      $(this).css('pointer-events', 'none')

      if ($(this).hasClass('slide-right') || $(this).hasClass('slide-next')) {
        slideClick += 1
        $('.bubble-counter').removeClass('text-primary')
        $(`#bubble_${slideClick}`).addClass('text-primary')
        setTimeout(() => $('.slide-right').css('pointer-events', ''), 900)
        $slider.animate({ scrollLeft: leftPos + 550 }, 800)
      } else if ($(this).hasClass('slide-left')) {
        slideClick -= 1
        setTimeout(() => $('.slide-left').css('pointer-events', ''), 900)
        $slider.animate({ scrollLeft: leftPos - 550 }, 800)
      }
    })
  })()

  // User dashboard activity feed + tabs
  ;(function userDashboardActivity () {
    const $activityFeed = $('#activity-feed')
    if ($activityFeed.length) {
      const activityUrl = $activityFeed.data('activityUrl')
      if (activityUrl) {
        $.ajax({ url: activityUrl })
      }
    }

    // TASKS / INBOX / ACTIVITY tabs
    $(document).on('click', '.submenu-tab-btn', function () {
      $('.user-feed, .user-unread, .reviews-defaults').hide()
      $('.submenu-tab-btn').removeClass('submenu-tab-active')
      $(this).addClass('submenu-tab-active')
      const dataId = $(this).data('id')
      $('.' + dataId).show()
    })

    // Dashboard background tweak
    const $mainContainer = $('.main-container')
    if ($mainContainer.length) {
      $mainContainer
        .addClass('main-container-wsub')
    }

    // Archive modal "Confirm" button path binding
    $(document).on('click', '.dismiss-btn', function () {
      const href = $(this).data('path')
      $('#confirm-btn').attr('href', href)
    })

    // Transaction rating hover colors
    const colorStarsAtAndBelow = function () {
      const thisRating = this.dataset.rating
      const ratings = this.parentElement.children

      for (const ratingStar of ratings) {
        if (ratingStar.dataset.rating <= thisRating) {
          $(ratingStar.firstChild).removeClass('grey-c')
        }
      }
    }

    const grayOutStars = function () {
      const thisRating = this.dataset.rating
      const ratings = this.parentElement.children

      for (const ratingStar of ratings) {
        if (ratingStar.dataset.rating <= thisRating) {
          $(ratingStar.firstChild).addClass('grey-c')
        }
      }
    }

    $('.rating-star').hover(colorStarsAtAndBelow, grayOutStars)
  })()

  window.userBandWidth()
  window.addEventListener('resize', window.userBandWidth)

  $(document).on('click', (e) => {
    if (e.target !== $('#user_band_hitbox')[0]) {
      $('#logout_panel').removeClass('toggle-tooltip-panel')
    }
  })

  $(document).on('click', '.close-notification', function () {
    // Cancel any pending timers so they don't re-show or move the panel
    clearTimeout(slideDownSuccess)
    clearTimeout(hideSuccess)
    clearTimeout(slideDownError)
    clearTimeout(hideError)

    $('#success_panel, #error_panel').attr('style', 'display:none;')
  })

  // Handle merge confirm button clicks in merge organizations/suppliers modal
  $(document).on('click', '#merge-confirm-btn', function () {
    $('#merge-org-submit').trigger('click')
    if (typeof window.cancelMerge === 'function') window.cancelMerge()
  })

  // Handle force merge toggle
  $(document).on('click', '#force-merge-toggle', function () {
    $('#force_flag').val($(this).prop('checked'))
  })

  // Handle organization search row clicks
  $(document).on('click', '.organization-results .search-row', function (event) {
    const organizationId = $(event.target).data('id') || $(this).data('id')
    const $container = $(this).closest('.organization-container')
    $container.find('.user-org-id').val(organizationId)
    const form = $container.find('form')[0]
    if (form) {
      if (window.Rails && window.Rails.fire) {
        window.Rails.fire(form, 'submit')
      } else {
        form.submit()
      }
    }
  })

  // Users filter buttons
  $(document).on('click', '#all_users', function () {
    $('#only_verified').val('false')
    $('#show_unverified').val('true')
    $('#all_users').removeClass('hollow')
    $('#verified_users').addClass('hollow')
    window.showUsersSpinner()
  })

  $(document).on('click', '#verified_users', function () {
    $('#only_verified').val('true')
    $('#show_unverified').val('false')
    $('#verified_users').removeClass('hollow')
    $('#all_users').addClass('hollow')
    window.showUsersSpinner()
  })

  document.addEventListener('up:fragment:inserted', initContractsTour)

  window.hideUsersSpinner()
  initSupplierOnboardingFlow()
  initSupplierSearchLanding()
  initContractsPage()
  initContractsTour()
  initOrganizationAutocomplete()
  initPageEvents()
  initConversationsPage()
  initSupplierOnboardingSetPassword()
  initBusinessInfo()
  initServiceAreas()

  globalsBooted = true
}

document.addEventListener('turbo:load', initGlobals)
document.addEventListener('DOMContentLoaded', initGlobals)

// Call once in case the script loads after DOMContentLoaded
initGlobals()
